import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import Link from "@readai/common/components/Link";
import usePageTitle from "@readai/common/hooks/usePageTitle";
import LINKS from "@readai/common/links";
import Stack from "@readai/pulse/components/Stack";

import EventNotification, {
  EventNotificationDescription,
  EventNotificationTitle,
  ReturnToRead,
} from "@app/booking/components/EventNotification";
import NotificationLayout from "@app/booking/layouts/NotificationLayout";

const NotFound = () => (
  <EventNotificationTitle>
    <Trans>The schedule you are trying to view does not exist.</Trans>
  </EventNotificationTitle>
);

const DefaultError = () => (
  <Stack spacing={1}>
    <EventNotificationTitle>
      <Trans>Oops!</Trans>
    </EventNotificationTitle>
    <EventNotificationDescription>
      <Trans>
        The schedule you are trying to view cannot be accessed at this time.
        Please reach out to the calendar owner or contact{" "}
        <Link href={LINKS.EMAIL.SUPPORT}>support@read.ai</Link> if the problem
        persists.
      </Trans>
    </EventNotificationDescription>
  </Stack>
);

const ErrorPage = ({ code }: { code: number }) => {
  usePageTitle(t`Schedule Event - ${code}`, {
    eventTitle: `Schedule Event - ${code}`,
  });

  return (
    <NotificationLayout>
      <EventNotification>
        {code === 404 ? <NotFound /> : <DefaultError />}
        <ReturnToRead />
      </EventNotification>
    </NotificationLayout>
  );
};

export default ErrorPage;
